export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10168.2cecc5c7.jpg";